<template>
  <button
    type="button"
    class="cart-qty-component pa-0"
    data-testid="cart-qty-component"
    :aria-label="$t('nav.cart.aria-label')"
    @click="navigateToCart"
  >
    <VAvatar
      v-show="cartQty"
      data-testid="VAvatar"
      size="18"
      color="secondary"
      class="qtyAvatar font12 font-weight-medium"
      :class="{ 'px-3' : cartQty > 99 }"
      :aria-label="$t('nav.cartqty.aria-label')"
      translate="no"
    >
      <span style="color: white" translate="no">
        {{ cartQty }}
      </span>
    </VAvatar>
    <VIcon
      :color="invert ? 'white' : 'primary'"
      aria-hidden="true"
    >
      {{ icons.mdiCartOutline }}
    </VIcon>
  </button>
</template>

<script lang="ts" setup>
import { mdiCartOutline } from '@mdi/js'
import { useCartStore } from '~/stores/cart'

interface Props {
  invert?: boolean
}

withDefaults(defineProps<Props>(), {
  invert: false
})

const emits = defineEmits<{ (e: 'clicked-cart'): void }>()

const cartStore = useCartStore()
const cartQty = computed(() => cartStore.cartQty)

const routeName = 'cart'

const icons = { mdiCartOutline }

const route = useRoute()
const router = useRouter()

const navigateToCart = () => {
  emits('clicked-cart')
  if (route.name !== routeName) {
    router.push({
      name: routeName
    })
  }
}
</script>

<style lang="scss" scoped>
.cart-qty-component {
  display: flex;
  position:relative;
  width: unset;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  font-variant-numeric: proportional-nums;
  -moz-font-feature-settings: "pnum";
  -webkit-font-feature-settings: "pnum";
  font-feature-settings: "pnum";
  .qtyAvatar {
    position:absolute;
    left:12px;
    z-index:10;
    cursor: pointer;
  }
  cursor: pointer;
}
</style>
